import {ChangeDetectionStrategy, Component, input} from "@angular/core";
import {ArkivnodeId} from "felles-ng2/tjenester/ressurser/generertNg2HttpKlient";
import {initDebugger} from "felles-ng2/støttefunksjoner/debug";
import {ArkivTrevisningKomponent} from "../arkiv-trevisning/arkiv-trevisning";

const debug = initDebugger('ArkivTrevisningAjsKomponent');

/**
 * Visning av arkiv - for bruk i ajs
 */
@Component({
    selector: 'arkiv-trevisning-ajs',
    templateUrl: 'arkiv-trevisning-ajs.html',
    styleUrl: 'arkiv-trevisning-ajs.scss',
    imports: [
        ArkivTrevisningKomponent
    ],
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ArkivTrevisningAjsKomponent {
    static ajsSelector = 'arkivTrevisningAjs';

    initiellMappeId = input<ArkivnodeId | null>(null);

    constructor() {
    }
}
